;(function () {
  'use strict'

  angular.module('contrast.badge').controller('csBadgeCtrl', csBadgeCtrl)

  function csBadgeCtrl() {
    var vm

    this.$onInit = function () {
      vm = this
      angular.extend(vm, {
        getValue: getValue,
        getClass: getClass
      })
    }

    function getValue() {
      return vm.csBadge
    }

    function getClass() {
      var c = ''
      if (getValue().length > 2) {
        c = 'cs-badge-small'
      }
      if (vm.csBadgePlaceholder) {
        c += ' cs-badge-placeholder'
      }
      return c
    }
  }
})()
